import { Typography } from '@automata/ui';
import MUIPopover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';

import { SxStyles } from 'types/global';

import { AuthenticationChecker } from './AuthenticationChecker';
import { Form } from './Form';
import { CommonProps } from './types';

import { ResourceActions } from '.';

type CommonPropsWithoutResourceAction = Omit<CommonProps, 'resourceAction'>;
export type Props = CommonPropsWithoutResourceAction & {
  anochorEl: HTMLElement;
  description?: string;
};

const styles = {
  popover: {
    p: 2,
    mt: 1,
    borderRadius: 2,
  },
} satisfies SxStyles;

export const CreateResourcePopover = ({
  anochorEl,
  description,
  ...commonPropsWithoutResourceAction
}: Props) => {
  const { open, onClose, resourceType } = commonPropsWithoutResourceAction;
  return (
    <AuthenticationChecker
      {...commonPropsWithoutResourceAction}
      resourceAction={ResourceActions.CREATE}
    >
      <MUIPopover
        anchorEl={anochorEl}
        open={open}
        onClose={onClose}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        PaperProps={{ sx: styles.popover }}
      >
        <Stack gap={1}>
          <Stack gap={1}>
            <Typography variant="subtitle2">Create {resourceType}</Typography>
            {description && (
              <Typography variant="body2">{description}</Typography>
            )}
          </Stack>
          <Form
            {...commonPropsWithoutResourceAction}
            resourceAction={ResourceActions.CREATE}
          />
        </Stack>
      </MUIPopover>
    </AuthenticationChecker>
  );
};
